import {getAmDashboards} from "./Dashboard.client";
import {PS_URLS, useCompany, useCompanyId} from "../../core";
import React, {useEffect, useState} from "react";
import {AMCompanyModel, AmDashboard} from "../../ps-types";
import {SectionsContent, SectionService, SectionsMenu} from "../Section";
import {DashboardBoardView} from "./DashboardView";
import {Button, Container, Grid, Header, Image, Segment, Sidebar, Menu, Icon} from "semantic-ui-react";
import {RefreshBtn} from "../index";
import {getAmProjectConfig} from "../../ps-models";
import {authStorage} from "../../auth";
import {loadCompanyModule} from "./DashboardConfigServiceRegistry";
import {getAmCompanyModelDownloadUrl, getAmCompanyModels} from "../../company/company.client";
import {useMessages} from "../../ui/MessagesProvider";
import {useHistory} from "react-router-dom";
import {TopLevelBanner} from "../../ui/TopLevelUIBanner";
import "./DashboardMainpage.css";

export function DashboardMainPage() {

  let companyId =  useCompanyId();

  let [dashboards, setDashboards] = useState<AmDashboard[]>();
  const company = authStorage.getCompany();
  const { namespace } = getAmProjectConfig(company);
  let companyLogoPath = "/am-logo.png";
  if(namespace === "PUBLICDEMO"){
    companyLogoPath = "/logo512.png";
  } else if(namespace === "Ampyr"){
    companyLogoPath = "/am-logos/Ampyr.png";
  } else if(namespace === "KingEnergy"){
    companyLogoPath = "/am-logos/king-energy-logo.png";
  } else if(namespace === "KelvinClearGen"){
    companyLogoPath = "/am-logos/Kelvin.png";
  } else if(namespace === "CGCDemo"){
    companyLogoPath = "/logo512.png"
  } else if(namespace === "ESG"){
    companyLogoPath = "/logo512.png"
  } else if(namespace === "Sunwealth") {
    companyLogoPath = "/logo512.png"
  }  else if(namespace === "Champlain") {
    companyLogoPath = "/logo512.png"
  } else if(namespace === "Voltpost") {
    companyLogoPath = "/logo512.png"
  } else if(namespace === "FourthPartner") {
    companyLogoPath = "/am-logos/FourthPartnerLogo.png";
  }


  useEffect(() => {
    getAmDashboards(companyId)
      .then((res) => {
        setDashboards(res);
      });
  }, [companyId]);

  const BASE_PATH = `/ps/:companyId/am/dashboard`;

  const sectionsService = new SectionService(BASE_PATH, companyId);

  dashboards?.filter(d => d.navigationConfig)
    .forEach((d, index) => {
      sectionsService.addSection({
        title: d.navigationConfig!.menuName || d.name,
        key: d.navigationConfig!.key,
        parent: d.navigationConfig!.parentId,
        isHome: index === 0,
        order: d.navigationConfig?.order,
        render: () => {
          return <div>
            {/* @TODO: Remove the hardcoded companyId, once done with demoing */}
            {((namespace === 'Sunwealth' || namespace === 'ESG') && (d.companyId !==company.id && companyId !== 'I2nQ3fH6KKpPaG8VAABl')) && <TopLevelBanner
            message={'Upgrade your subscription to edit this dashboard and evaluate your portfolio performance.'}
            />}
                    <DashboardBoardView
                        key={d.id}
                        dashboardId={d.id} dashboardData={d} />
            {/*@TODO: Here is where the banner would show up */}
            {/*{((namespace === 'ESG') && d.companyId ===company.id) && <TopLevelBanner*/}
            {/*    message={'THIS IS OUR BANNER FOR ESG.'}*/}
            {/*/>}*/}
                  </div>
        }
      });
  });


  let module = loadCompanyModule();

  module.overrideDashboardSections(sectionsService);

  return (
    <>
    <div id="dashboard-main-page">
        <div className="dashboard-header">
          <Container fluid>
            <div className="header-content">
              <div className="logo-section">
                <div className="logo-container">
                  <Image 
                    src={companyLogoPath} 
                    className="company-logo"
                  />
                </div>
              </div>

              <div className="navigation-section">
                  <SectionsMenu sectionService={sectionsService} />
              </div>

              <div className="actions-section">
                <div className="actions-wrapper ps-button-wrapper">
                  <RefreshBtn />
                </div>
              </div>
            </div>
          </Container>
        </div>
    </div>
      <SectionsContent sectionService={sectionsService}/></>
  );
}